import { NameFilterENUM, TypeFilterENUM } from 'types/filtersType';
import CustomModal from 'components/CustomModal/CustomModal';
import Button from 'components/Button';
import useCheckMatchApplyedAndSavedFilters from 'utils/useCheckMatchApplyedAndSavedFilters';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  setAppliedFilters,
  setRequestSentFilters,
} from 'store/filter/filterSlice';

import type { SectionFilterType } from '../FilterSection/FilterSection';
import DateRangeFields from '../DateRange/DateRangeFields/DateRangeFields';
import StyledModalBody from './FiltersModal.styles';
import Toggle from '../Toggle/Toggle';

type PropsType = {
  open: boolean;
  onClose: () => void;
};

const FiltersModal:React.FC<PropsType> = (props) => {
  const dispatch = useAppDispatch();
  const isApplied = useAppSelector((state) => state.filterSlice.isApplied);
  const checkMatchApplyedAndSavedFilters = useCheckMatchApplyedAndSavedFilters();
  const handleApplyFilters = async () => {
    checkMatchApplyedAndSavedFilters();
    dispatch(setAppliedFilters());
    dispatch(setRequestSentFilters(true));
  };
  // TODO where and how we should to clear filters?
  return (
    <CustomModal
      open={props.open}
      onClose={props.onClose}
      isBorderRounded
    >
      <StyledModalBody>
        <div className="filters-modal__header-wrapper">
          <h3 className="filters-modal__title">Filters</h3>
          <div className="filters-modal__buttons-wrapper">
          <Button
            variant="contained"
            className="filters-modal__apply-btn"
            disabled={isApplied}
            onClick={handleApplyFilters}
          >
            Apply filters
          </Button>

          <Button
            variant="outlined"
            className="filters-modal__close-btn"
            onClick={props.onClose}
          >
            Close
          </Button>
          </div>
        </div>

      <div className="filters-modal__filters-wrapper">
        <DateRangeFields />
        <Toggle />
      </div>

      </StyledModalBody>
    </CustomModal>
  );
};

export default FiltersModal;
